export enum enumOriginOfCellPhoneNoEnum {
  Imported = 1,
  FICA,
  'Front End',
  'Call Centre',
  'Cellphone Registration',
  'HQ Portal'= 7,
  None= 99,
  '3rd Party'= 8
}

export namespace enumOriginOfCellPhoneNoEnum {
  export function values() {
    return Object.keys(enumOriginOfCellPhoneNoEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
